var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterGithub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1078_4053)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.653 1.03516C5.1318 1.03516 0.654297 5.53016 0.654297 11.0752C0.654297 15.5102 3.5193 19.2727 7.4943 20.6014C7.9943 20.6939 8.1768 20.3839 8.1768 20.1177C8.1768 19.8789 8.16805 19.2477 8.16305 18.4102C5.3818 19.0164 4.7943 17.0639 4.7943 17.0639C4.34055 15.9039 3.6843 15.5952 3.6843 15.5952C2.77555 14.9727 3.7518 14.9852 3.7518 14.9852C4.75555 15.0564 5.28305 16.0202 5.28305 16.0202C6.17555 17.5539 7.6243 17.1114 8.1943 16.8539C8.2843 16.2052 8.54305 15.7627 8.8293 15.5114C6.6093 15.2577 4.2743 14.3964 4.2743 10.5502C4.2743 9.45392 4.6643 8.55766 5.3043 7.85516C5.20055 7.60141 4.85805 6.58016 5.4018 5.19891C5.4018 5.19891 6.2418 4.92891 8.1518 6.22766C8.9493 6.00516 9.8043 5.89391 10.6555 5.89016C11.5043 5.89516 12.3605 6.00516 13.1593 6.22891C15.068 4.93016 15.9068 5.20016 15.9068 5.20016C16.4518 6.58266 16.1093 7.60266 16.0068 7.85641C16.648 8.55891 17.0343 9.45517 17.0343 10.5514C17.0343 14.4077 14.6968 15.2564 12.4693 15.5052C12.828 15.8152 13.148 16.4277 13.148 17.3639C13.148 18.7064 13.1355 19.7889 13.1355 20.1177C13.1355 20.3864 13.3155 20.6989 13.823 20.6002C17.7918 19.2702 20.6543 15.5089 20.6543 11.0752C20.6543 5.53016 16.1768 1.03516 10.653 1.03516Z",
    fill: "white",
    fillOpacity: 0.75
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1078_4053"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.654297 0.827148)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterGithub);
export default __webpack_public_path__ + "static/media/footer_github.bd9f57640f0072936576409582107bcd.svg";
export { ForwardRef as ReactComponent };